import moment from "moment-timezone";

const DEFAULT_TIMEZONES = moment.tz.names();
const TIMEZONE_KEY = "timezone";

const state = {
  timezone: "UTC",
  timezonesList: DEFAULT_TIMEZONES
};

const mutations = {
  setTimezone(state, timezone) {
    state.timezone = timezone;
  }
};

const actions = {
  initTimezone({ commit }, {defaultTimezone, channelId}) {
    const savedTimezone = localStorage.getItem(`${TIMEZONE_KEY} - ${channelId}`);

    if (savedTimezone) {
      commit("setTimezone", savedTimezone);
    } else {
      commit("setTimezone", defaultTimezone);
    }
  },
  selectTimezone({ state, commit }, {timezone, channelId}) {
    const timezoneIndex = state.timezonesList.find(tz => tz === timezone);

    if (timezoneIndex < 0) {
      console.warn(
        `Timezone <${timezone}> not found in available timezones list`
      );
      return;
    }

    commit("setTimezone", timezone);
    localStorage.setItem(`${TIMEZONE_KEY} - ${channelId}`, timezone);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
